<template>
  <span
    class="app-icon-wrapper"
    :class="customClass"
    :style="wrapperStyle"
    :title="title"
  >
    <!-- PIX (Vetor Oficial 16x16 SVGRepo/Bacen) -->
    <svg
      v-if="iconNormalized === 'pix'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      class="app-svg-icon"
    >
      <path d="M11.917 11.71a2.046 2.046 0 0 1-1.454-.602l-2.1-2.1a.4.4 0 0 0-.551 0l-2.108 2.108a2.044 2.044 0 0 1-1.454.602h-.414l2.66 2.66c.83.83 2.177.83 3.007 0l2.667-2.668h-.253zM4.25 4.282c.55 0 1.066.214 1.454.602l2.108 2.108a.39.39 0 0 0 .552 0l2.1-2.1a2.044 2.044 0 0 1 1.453-.602h.253L9.503 1.623a2.127 2.127 0 0 0-3.007 0l-2.66 2.66h.414z"/>
      <path d="m14.377 6.496-1.612-1.612a.307.307 0 0 1-.114.023h-.733c-.379 0-.75.154-1.017.422l-2.1 2.1a1.005 1.005 0 0 1-1.425 0L5.268 5.32a1.448 1.448 0 0 0-1.018-.422h-.9a.306.306 0 0 1-.109-.021L1.623 6.496c-.83.83-.83 2.177 0 3.008l1.618 1.618a.305.305 0 0 1 .108-.022h.901c.38 0 .75-.153 1.018-.421L7.375 8.57a1.034 1.034 0 0 1 1.426 0l2.1 2.1c.267.268.638.421 1.017.421h.733c.04 0 .079.01.114.024l1.612-1.612c.83-.83.83-2.178 0-3.008z"/>
    </svg>

    <!-- Boleto / Código de Barras -->
    <svg
      v-else-if="iconNormalized === 'barcode' || iconNormalized === 'boleto'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <line x1="3" y1="4" x2="3" y2="20"></line>
      <line x1="7" y1="4" x2="7" y2="20"></line>
      <line x1="11" y1="4" x2="11" y2="20"></line>
      <line x1="15" y1="4" x2="15" y2="20"></line>
      <line x1="19" y1="4" x2="19" y2="20"></line>
      <line x1="21" y1="4" x2="21" y2="20"></line>
    </svg>

    <!-- Cartão de Crédito / Débito -->
    <svg
      v-else-if="iconNormalized === 'card' || iconNormalized === 'cartao' || iconNormalized === 'cartão'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
      <line x1="1" y1="10" x2="23" y2="10"></line>
    </svg>

    <!-- Dinheiro / Espécie -->
    <svg
      v-else-if="iconNormalized === 'cash' || iconNormalized === 'dinheiro' || iconNormalized === 'especie'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <rect x="2" y="6" width="20" height="12" rx="2"></rect>
      <circle cx="12" cy="12" r="2"></circle>
    </svg>

    <!-- Banco / Transferência / TED / DOC / Depósito -->
    <svg
      v-else-if="iconNormalized === 'bank' || iconNormalized === 'transferencia' || iconNormalized === 'transferência' || iconNormalized === 'ted'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <path d="M3 21h18M3 10h18M5 10v11M19 10v11M9 10v11M15 10v11M12 3 2 10h20Z"></path>
    </svg>

    <!-- Alerta / Aviso / Renegociação (>60d) -->
    <svg
      v-else-if="iconNormalized === 'alert' || iconNormalized === 'warning' || iconNormalized === 'renegociacao' || iconNormalized === 'renegociação'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>

    <!-- Relógio / Pendente / Horário -->
    <svg
      v-else-if="iconNormalized === 'clock' || iconNormalized === 'pendente' || iconNormalized === 'time' || iconNormalized === 'schedule'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>

    <!-- Calendário / Vencimento / Data -->
    <svg
      v-else-if="iconNormalized === 'calendar' || iconNormalized === 'data' || iconNormalized === 'vencimento'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>

    <!-- Check / Sucesso -->
    <svg
      v-else-if="iconNormalized === 'check' || iconNormalized === 'success' || iconNormalized === 'sucesso'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>

    <!-- Erro / Close / Cancelar -->
    <svg
      v-else-if="iconNormalized === 'close' || iconNormalized === 'error' || iconNormalized === 'falha' || iconNormalized === 'cancel'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="15" y1="9" x2="9" y2="15"></line>
      <line x1="9" y1="9" x2="15" y2="15"></line>
    </svg>

    <!-- Enviar / Send / Aviãozinho -->
    <svg
      v-else-if="iconNormalized === 'send' || iconNormalized === 'enviar'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <line x1="22" y1="2" x2="11" y2="13"></line>
      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
    </svg>

    <!-- Filtro / Filter -->
    <svg
      v-else-if="iconNormalized === 'filter' || iconNormalized === 'filtro'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
    </svg>

    <!-- Busca / Search -->
    <svg
      v-else-if="iconNormalized === 'search' || iconNormalized === 'busca'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>

    <!-- WhatsApp -->
    <svg
      v-else-if="iconNormalized === 'whatsapp'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
    </svg>

    <!-- Copiar / Copy -->
    <svg
      v-else-if="iconNormalized === 'copy' || iconNormalized === 'copiar'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
    </svg>

    <!-- Usuário / Pessoa Física -->
    <svg
      v-else-if="iconNormalized === 'user' || iconNormalized === 'pessoa'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>

    <!-- Empresa / Prédio / Pessoa Jurídica -->
    <svg
      v-else-if="iconNormalized === 'building' || iconNormalized === 'empresa'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
      <line x1="9" y1="22" x2="9" y2="22.01"></line>
      <line x1="15" y1="22" x2="15" y2="22.01"></line>
      <line x1="8" y1="6" x2="8.01" y2="6"></line>
      <line x1="12" y1="6" x2="12.01" y2="6"></line>
      <line x1="16" y1="6" x2="16.01" y2="6"></line>
      <line x1="8" y1="10" x2="8.01" y2="10"></line>
      <line x1="12" y1="10" x2="12.01" y2="10"></line>
      <line x1="16" y1="10" x2="16.01" y2="10"></line>
      <line x1="8" y1="14" x2="8.01" y2="14"></line>
      <line x1="12" y1="14" x2="12.01" y2="14"></line>
      <line x1="16" y1="14" x2="16.01" y2="14"></line>
      <line x1="8" y1="18" x2="8.01" y2="18"></line>
      <line x1="12" y1="18" x2="12.01" y2="18"></line>
      <line x1="16" y1="18" x2="16.01" y2="18"></line>
    </svg>

    <!-- Sincronização / Recorrente / Sync -->
    <svg
      v-else-if="iconNormalized === 'sync' || iconNormalized === 'refresh' || iconNormalized === 'recorrente'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.3"></path>
    </svg>

    <!-- Documento / Nota / Contrato / File -->
    <svg
      v-else-if="iconNormalized === 'file' || iconNormalized === 'nota' || iconNormalized === 'contrato' || iconNormalized === 'documento'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>

    <!-- Inbox / Caixa Vazia / Empty -->
    <svg
      v-else-if="iconNormalized === 'inbox' || iconNormalized === 'empty' || iconNormalized === 'caixa'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline>
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
    </svg>

    <!-- Sparkles / Brilho / Sucesso Limpo -->
    <svg
      v-else-if="iconNormalized === 'sparkles' || iconNormalized === 'clean' || iconNormalized === 'ok'"
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="app-svg-icon"
    >
      <path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3z"></path>
    </svg>

    <!-- Fallback padrão (círculo pontilhado) -->
    <svg
      v-else
      :width="iconSize"
      :height="iconSize"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      class="app-svg-icon"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  </span>
</template>

<script>
export default {
  name: "AppIcon",
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 14
    },
    color: {
      type: String,
      default: null
    },
    customClass: {
      type: [String, Object, Array],
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    iconNormalized() {
      if (!this.name) return "";
      return String(this.name).toLowerCase().trim();
    },
    iconSize() {
      if (typeof this.size === "number") return this.size;
      const num = parseInt(this.size, 10);
      return !isNaN(num) ? num : 14;
    },
    wrapperStyle() {
      const style = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        verticalAlign: "middle"
      };
      if (this.color) {
        style.color = this.color;
      }
      return style;
    }
  }
};
</script>

<style scoped>
.app-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  flex-shrink: 0;
}

.app-svg-icon {
  display: block;
  flex-shrink: 0;
  transition: transform 0.15s ease, color 0.15s ease;
}
</style>
